<template>
  <div class="work-container">
    <h1>Projects</h1>
    <div class="projects-grid">
      <v-card
        v-for="project in projects"
        :key="project.id"
        class="project-card"
      >
        <v-card-title>{{ project.title }}</v-card-title>
        <v-card-text>
          <p class="description">
            {{ project.description }}
          </p>
          <div class="tags">
            <v-chip v-for="tag in project.tags" :key="tag" small>
              {{ tag }}
            </v-chip>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            v-if="project.link"
            :href="project.link"
            target="_blank"
            rel="noopener"
            color="primary"
          >
            {{ project.linkText || 'Visit' }}
          </v-btn>
          <v-btn
            v-if="project.github"
            :href="project.github"
            target="_blank"
            rel="noopener"
            outlined
          >
            {{ project.githubText || 'GitHub' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Work',
  data() {
    return {
      projects: [
        {
          id: 1,
          title: 'GuruNearMe website',
          description:
            'A directory platform connecting students with tutors and coaching centers across India.',
          tags: ['Angular', 'Typescript'],
          link: 'https://www.gurunearme.com/',
          linkText: 'Visit',
        },
        {
          id: 2,
          title: 'GuruNearMe Mobile App',
          description: 'Mobile app equivalent of the GuruNearMe website.',
          tags: ['React Native'],
          link: 'https://play.google.com/store/apps/details?id=com.gurunearme',
          linkText: 'Android',
          github: 'https://apps.apple.com/us/app/guru-near-me/id6744638352',
          githubText: 'iPhone',
        },
        {
          id: 3,
          title: 'VerbaPlay',
          description: 'Select an alphabet and form words to score points.',
          tags: ['ReactJS', 'NextJS'],
          link: 'https://www.verbaplay.com/',
          linkText: 'Visit',
          github: 'https://github.com/ankitkante/guess-words-from-letter',
          githubText: 'View Source',
        },
      ],
    }
  },
}
</script>

<style scoped>
.work-container {
  padding: 2rem;
  max-width: 1000px;
  margin: 0 auto;
}

h1 {
  font-size: 2.5rem;
  margin-bottom: 0.5rem;
}

.subtitle {
  color: #666;
  margin-bottom: 2rem;
  font-size: 1.1rem;
}

.projects-grid {
  display: grid;
  gap: 2rem;
}

.project-card {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 1.5rem;
  transition: box-shadow 0.3s ease;
}

.project-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.project-card h3 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

.description {
  color: #555;
  margin-bottom: 1rem;
}

.tags {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}

.tag {
  background: #f0f0f0;
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
  font-size: 0.85rem;
}

.links {
  display: flex;
  gap: 0.75rem;
}

.btn {
  display: inline-block;
  padding: 0.5rem 1rem;
  background: #0066cc;
  color: white;
  text-decoration: none;
  border-radius: 4px;
  font-size: 0.9rem;
  transition: background 0.3s ease;
}

.btn:hover {
  background: #0052a3;
}

.btn-secondary {
  background: #666;
}

.btn-secondary:hover {
  background: #444;
}
</style>
